import { Suspense, lazy } from 'react';
import { NavLink } from 'react-router-dom';

// Lazy-load search so its Fuse index doesn't ship with the initial bundle
const CmdKSearch = lazy(() => import('./CmdKSearch'));

const items: Array<{ to: string; label: string }> = [
  { to: '/pregled', label: 'Pregled' },
  { to: '/operativa', label: 'Naša operativa' },
  { to: '/taktike-protivnika', label: 'Taktike protivnika' },
  { to: '/brojke', label: 'Brojke' },
  { to: '/incidenti', label: 'Incidenti' },
  { to: '/metodologija', label: 'Metodologija' },
];

export default function TopNav() {
  return (
    <header className="sticky top-0 z-30 border-b border-neutral-200 bg-paper/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center gap-6 px-6 py-3">
        <NavLink to="/" className="font-mono text-sm font-medium tracking-tight text-ink">
          posmatrači
        </NavLink>
        <nav className="flex flex-1 items-center gap-4 text-sm">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) =>
                [
                  'rounded px-1 py-0.5 transition-colors',
                  isActive
                    ? 'text-ink font-medium underline decoration-2 underline-offset-4'
                    : 'text-neutral-600 hover:text-ink',
                ].join(' ')
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>
        <NavLink
          to="/odgovori"
          className={({ isActive }) =>
            [
              'hidden rounded-md border px-3 py-1.5 text-sm font-medium transition-colors md:inline-flex',
              isActive
                ? 'border-axis-op bg-axis-op text-white'
                : 'border-axis-op/40 bg-axis-op-tint text-axis-op-ink hover:border-axis-op hover:bg-axis-op hover:text-white',
            ].join(' ')
          }
        >
          Originalni odgovori
        </NavLink>
        <Suspense fallback={null}>
          <CmdKSearch />
        </Suspense>
      </div>
    </header>
  );
}
